import React from "react";
import { useSmartNavigate } from "@/hooks/use-smart-navigate";

const ProjectExpandLink = ({ id, action }) => {
  const { navigateToProjectDetail } = useSmartNavigate();

  const handleClick = (e) => {
    e.stopPropagation(); // Prevent row click from triggering
    if (action) {
      navigateToProjectDetail(id);
    }
  };

  return (
    <a onClick={handleClick}>
      <i className="fas fa-expand-arrows-alt text-lg"></i>
    </a>
  );
};

export default ProjectExpandLink;


